import { Button, Modal } from "antd";
import React from "react";
import { TituloModal } from "../components/tituloModal/TituloModal";

export default function ModalPage({
  titulo,
  isVisible,
  children,
  handleOk,
  handleCancel,
  okLabel ="Ok",
  loadingOk = false,
}) {
  return (
    <Modal
      title={<TituloModal texto={titulo} />}  
      open={isVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button size="small" key="1" onClick={handleCancel}>
          Cerrar
        </Button>,
        <Button size="small" type="primary" key="2" onClick={handleOk} loading={loadingOk}>
          {okLabel}
        </Button>,
      ]}
    >
      {children}
    </Modal>
  );
}
